import React from 'react';

const SafeIcon = ({ icon: Icon, className, ...rest }) => {
  if (!Icon) return null;
  
  return <Icon className={className || ''} {...rest} />;
};

export default SafeIcon;